import { posts, type Post } from '@/mocks/entertainment';

function toneBadge(tone: Post['badgeTone'], text: string) {
  const map: Record<string, string> = {
    primary: 'bg-primary-500 text-background-50',
    accent: 'bg-accent-500 text-background-50',
    secondary: 'bg-secondary-500 text-background-50',
  };
  return <span className={`px-2.5 py-1 rounded-full text-xs font-bold ${map[tone]}`}>{text}</span>;
}

const realtime = [...posts].sort((a, b) => a.minutes - b.minutes).slice(0, 6);

export default function RealtimeSection() {
  return (
    <section id="realtime" className="mx-auto max-w-7xl px-4 md:px-6 pt-16 md:pt-24">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold tracking-widest text-primary-600 mb-2">
            <span className="flex items-center gap-1.5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>REALTIME
            </span>
          </p>
          <h3 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">实时速递</h3>
          <p className="mt-2 text-sm text-foreground-600">全网滚动追踪，重大消息第一时间送到你面前。</p>
        </div>
        <div className="flex items-center gap-2 text-xs text-foreground-600 whitespace-nowrap">
          <span className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 font-medium">每 60s 更新</span>
          <span className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-700 font-medium">今日已推 300+ 条</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {realtime.map((p) => (
          <article key={p.id} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition flex flex-col">
            <div className="relative overflow-hidden h-44 md:h-52">
              <img
                src={p.image}
                alt={p.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/60 backdrop-blur text-background-50 text-xs flex items-center gap-1">
                <i className="ri-time-line"></i>{p.minutes} 分钟前
              </span>
              <span className="absolute bottom-3 left-3 text-xs text-background-100">{p.views} 阅读</span>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex items-center justify-between mb-2">
                {toneBadge(p.badgeTone, `${p.badge}`)}
                <span className="text-xs text-foreground-500">{p.catName}</span>
              </div>
              <h4 className="text-base font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition">
                {p.title}
              </h4>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{p.summary}</p>
              <div className="mt-auto pt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-500">最快吃瓜 · 独家</span>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-semibold">
                  吃这个瓜 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}